module.exports = __webpack_public_path__ + "img/performance-tiao-icon4.ad7d83da.png";